// @ts-check

(function($) {

let $mainHeader;
const headerMinClass = 'minimized';

// buildDropdowns()
// Takes an array of id strings and finds two objects per string in the current DOM:
// a button and a dropdown menu. The dropdown must have the same id as the button, appended with `-dropdown`
// Returns an array of objects, each with the original id, a `$button` jQuery object, and a `$dropdown` jQuery object
const buildDropdowns = () => {
  return $('.wrapper__button--dropdown').toArray().map((item) => {
    const $thisButton = $(item);
    const id = $thisButton.attr('id');
    const $thisDropdown = $('#' + id + '-dropdown');
    $thisButton.attr('aria-controls', id + '-dropdown');
    $thisButton.attr('aria-expanded', 'false');

    const thisDropdown = {
      id: id,
      $button: $thisButton,
      $dropdown: $thisDropdown
    }

    return thisDropdown;
  });
}

/**
 * @param {ReturnType<typeof buildDropdowns>} dropdownObjects
 */
const clearActive = (dropdownObjects, excludeName = '') => {
  dropdownObjects.forEach((dropdownObject) => {
    if (dropdownObject.id !== excludeName) {
      dropdownObject.$button.removeClass('active');
      dropdownObject.$dropdown.slideUp();
      dropdownObject.$button.attr('aria-expanded', 'false');
    }
  });
};

jQuery(document).ready(function documentLoaded($) {
  const utilDropdowns = buildDropdowns()

  utilDropdowns.map((dropdownObject) => {
    dropdownObject.$button.on('click', () => {
      var expanded = (dropdownObject.$button.attr('aria-expanded') == 'true');
      dropdownObject.$button.attr('aria-expanded', '' + !expanded);
      clearActive(utilDropdowns, dropdownObject.id);
      dropdownObject.$button.toggleClass('active');
      dropdownObject.$dropdown.slideToggle();
    });
    // If focus leaves dropdown, close it up.
    dropdownObject.$dropdown.find('a').on('blur', (e) => {
      setTimeout(() => {
        var $active = $(':focus');
        if ($active.closest('.dropdown').attr('id') != (dropdownObject.id + '-dropdown')) {
          dropdownObject.$button.removeClass('active');
          dropdownObject.$dropdown.slideUp();
          dropdownObject.$button.attr('aria-expanded', 'false');
        }
      }, 200);
    });
  });

  $(document).on('keyup', (e) => {
    if (e.key == "Escape") {
      utilDropdowns.map((dropdownObject) => {
        const expanded = (dropdownObject.$button.attr('aria-expanded') == 'true');
        if (expanded) {
          clearActive(utilDropdowns);
        }
      });

      const $button = $('#main-nav-button');
      const $buttonContent = $button.find('span');
      if ($button.attr('aria-expanded') === 'true') {
        $buttonContent.text('Menu');
        $button.attr('aria-expanded', 'false');
        $button.removeClass('active');
        $('#main-nav-dropdown').slideUp();
      }
    }
  });

  $('#main-nav-button').on('click', (event) => {
    const $button = $(event.currentTarget);
    const $buttonContent = $button.find('span');
    $button.toggleClass('active');
    if ($button.hasClass('active')) {
      $buttonContent.text('Close');
      $button.attr('aria-expanded', 'true');
    } else {
      $buttonContent.text('Menu');
      $button.attr('aria-expanded', 'false');
    }
    $('#main-nav-dropdown').slideToggle();
  })

  setTimeout(() => {
    scrollCheck();
  }, 500);

  const makeMenuFocusTrap = () => {
    const menuButton = document.getElementById('main-nav-button');
    const menu = document.getElementById('main-nav-dropdown');

    const menuButtonHiddenBreakpoint = window.matchMedia('(min-width: 64em)');
  
    if (!(menu instanceof HTMLElement) || !(menuButton instanceof HTMLButtonElement)) return;
  
    const treeWalker = document.createTreeWalker(
      menu,
      NodeFilter.SHOW_ELEMENT,
      {
        acceptNode: (node) => {
          if (!(node instanceof HTMLElement)) return NodeFilter.FILTER_SKIP;
  
          /*
            Must use `node.getAttribute('tabindex')` to distinguish the
            "actually set to -1 in the markup" case from the "just a normal
            non-interactive element whose `tabindex` attribute hasn't been
            explicitly set" case (because `node.tabIndex` returns `-1` for
            BOTH of those). Then for all other cases we need `node.tabIndex`
            to get the effective tab-index (because `node.getAttribute('tabindex')`
            returns `null` if the `tabindex` attribute hasn't been explicitly set,
            and we're looking for effective values of `0` and above).
          */
          const tabIndexIsNegativeOne =
            node.getAttribute('tabindex') === '-1';
  
          // rule out if tabindex isn't >= 0 AND isn't EXPLICITLY -1
          if (!tabIndexIsNegativeOne && node.tabIndex < 0) {
            return NodeFilter.FILTER_SKIP;
          }
  
          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );
  
    /** @type {HTMLElement[]} */
    const focusableElements = [];
  
    /** @type {Node | null} */
    let currentNode = null;
    while ((currentNode = treeWalker.nextNode())) {
      if (currentNode instanceof HTMLElement) {
        focusableElements.push(currentNode);
      }
    }
  
    const firstFocusable = focusableElements.find((e) => e.tabIndex >= 0);
    const lastFocusable = focusableElements.pop();
  
    if (!firstFocusable || firstFocusable === lastFocusable) return;

    document.addEventListener('keydown', (event) => {
      if (menuButtonHiddenBreakpoint.matches) return;

      if (event.key !== 'Tab') return;

      const { activeElement } = document;
      if (!activeElement) return;
      if (activeElement !== menuButton && !menu.contains(activeElement)) return;
      if (activeElement === menuButton && !menuButton.matches('[aria-expanded="true"]')) return;

      if (event.shiftKey) {
        if (activeElement === firstFocusable) {
          event.preventDefault();
          menuButton.focus();
        } else if (
          /*
            Account for case where something w/ -1 tabindex BEFORE `firstFocusable` has received programmatic focus.
            Note: leave the `&` (it's NOT a typo for `&&`).
          */
          menu.contains(activeElement) &&
          activeElement.compareDocumentPosition(firstFocusable) &
          Node.DOCUMENT_POSITION_FOLLOWING
        ) {
          event.preventDefault();
          menuButton.focus();
        } else if (menuButton === activeElement) {
          if (lastFocusable) {
            event.preventDefault();
            lastFocusable.focus();
          }
        }
      } else if (activeElement === lastFocusable) {
        event.preventDefault();
        menuButton.focus();
      } else if (
        /*
          Account for case where something w/ -1 tabindex AFTER `lastFocusable` has received programmatic focus.
          Note: leave the `&` (it's NOT a typo for `&&`).
        */
        menu.contains(activeElement) &&
        lastFocusable &&
        activeElement.compareDocumentPosition(lastFocusable) &
          Node.DOCUMENT_POSITION_PRECEDING
      ) {
        event.preventDefault();
        menuButton.focus();
      } else if (menuButton === activeElement) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  };

  makeMenuFocusTrap();
});

const scrollCheck = () => {
  if (!$mainHeader) {
    $mainHeader = $('.main-header');
  }

  if (Number($(window).scrollTop()) < 75) {
    $mainHeader.removeClass(headerMinClass);
  } else {
    $mainHeader.addClass(headerMinClass);
  }
};

$(window).scroll(() => {
  scrollCheck();
});

})(jQuery);